import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type MonteCarloGeneralSettingsDto, type MonteCarloGeneralSettingsUpdateDto, updateGeneralSettings } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateProjectionCashFlowGeneralSettings = (): UseMutationResult<
    MonteCarloGeneralSettingsDto,
    AxiosError,
    MonteCarloGeneralSettingsUpdateDto
> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateGeneralSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.saeCashFlowProjectionGeneralSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
        },
    });
};
